import ErpLogList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/logs") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpLogList();
    }
}